import React from 'react';
import { TourPlanListProps } from '../common/types';
import { useNavigate } from "react-router-dom";


interface TourPlanListPropsExtended extends TourPlanListProps {
  onAddTourPlan: () => void;
}

const TourPlanList: React.FC<TourPlanListPropsExtended> = ({ tourPlans, isLoading, onViewApproval, onAddTourPlan }) => {
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
        <div className="p-8 text-center">
          <div className="w-8 h-8 mx-auto border-b-2 border-blue-600 rounded-full animate-spin"></div>
          <p className="mt-2 text-gray-500">Loading tour plans...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden bg-white border border-gray-200 rounded-lg shadow-sm">
      <div className="p-6">
        <div className="grid grid-cols-1 gap-6 mb-8 md:grid-cols-3">
          {/* Approve Tour Plan Card */}
          {/* <div
            className="p-6 transition-shadow border border-gray-200 rounded-lg cursor-pointer hover:shadow-md hover:border-blue-500"
            onClick={onViewApproval}
          >
            <h3 className="mb-2 text-lg font-semibold text-blue-600">Approve Tour Plan</h3>
            <p className="text-sm text-gray-600">Approve & unlock tour plans of employees for the selected month.</p>
          </div> */}

          {/* Add Tour Plan Card - Opens Modal */}
          <div
            className="p-6 transition-shadow border border-gray-200 rounded-lg cursor-pointer hover:shadow-md hover:border-blue-500"
            onClick={onAddTourPlan}
          >
            <h3 className="mb-2 text-lg font-semibold text-blue-600">Add Tour Plan (Monthly)</h3>
            <p className="text-sm text-gray-600">Add monthly tour plan for employee.</p>
          </div>

          {/* Modify Tour Plan Card */}
          {/* <div
            className="p-6 transition-shadow border border-gray-200 rounded-lg cursor-pointer hover:shadow-md hover:border-blue-500"
            onClick={() => alert('Modify Tour Plan - This will navigate to a separate page')}
          >
            <h3 className="mb-2 text-lg font-semibold text-blue-600">Modify Tour Plan</h3>
            <p className="text-sm text-gray-600">Revised Tour Plan worked only in case of Approved or Not Submitted.</p>
          </div> */}
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {/* Deviation Approval Card */}
          {/* <div
            className="p-6 transition-shadow border border-gray-200 rounded-lg cursor-pointer hover:shadow-md hover:border-blue-500"
            onClick={() => alert('Deviation Approval - This will navigate to a separate page')}
          >
            <h3 className="mb-2 text-lg font-semibold text-blue-600">Deviation Approval</h3>
            <p className="text-sm text-gray-600">Approve & deny tour plans deviation request of employee.</p>
          </div> */}

          {/* View Tour Plan Card */}
          <div
            className="p-6 transition-shadow border border-gray-200 rounded-lg cursor-pointer hover:shadow-md hover:border-blue-500"
            onClick={() => navigate("/tour-plans")}

          >
            <h3 className="mb-2 text-lg font-semibold text-blue-600">View Tour Plan</h3>
            <p className="text-sm text-gray-600">View the tour plans of the employees.</p>
          </div>

          {/* Tour Plan Block/Unblock Card */}
          {/* <div
            className="p-6 transition-shadow border border-gray-200 rounded-lg cursor-pointer hover:shadow-md hover:border-blue-500"
            onClick={() => alert('Tour Plan Block/Unblock - This will navigate to a separate page')}
          >
            <h3 className="mb-2 text-lg font-semibold text-blue-600">Tour Plan Block/Unblock</h3>
            <p className="text-sm text-gray-600">List of blocked employees Who have not submitted next month's tour plan before the submission day.</p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default TourPlanList;
